// The whole code is copied from VPC.

import {
  DataQualityAssetType,
  DataQualityDetailProps,
  DataQualityType,
  EmbeddableDataQualityStatusChip,
  TableauUser,
} from '@tableau/data-catalog-client-components';
import { removeNulls } from '@tableau/data-structures';
import * as React from 'react';
import { AppUrls } from '../../../../app/AppUrls';
import { L10n } from '../../../../common/utils/L10n';
import { ContentType } from '../../../models/ContentType';
import { DataQualityOwner } from '../../../models/DataQualityOwner';
import { IDataQualityIndicator } from '../../../models/httpClient/MetaDataResults';
import { DataSource } from '../../../models/SearchResultTypes';
import { IconComponentProps } from './LinkCell';

export const CERTIFIED_INDICATOR_TYPE = 'CERTIFIED';
const DataQualityIndicatorStyle: React.CSSProperties = {
  position: 'relative',
  left: '11px',
  width: 'fit-content',
};

export class DataQualityIndicator extends React.Component<IconComponentProps, {}> {
  public render() {
    const contentTypeWithDQW = this.props.data as DataSource;

    if (!contentTypeWithDQW.contentDetail) {
      return <></>;
    }

    const details = dataQualityIndicatorInfosToProps(
      {
        assetUrl: urlForContentType(this.props.urls, contentTypeWithDQW.contentType, contentTypeWithDQW.id),
        assetName: contentTypeWithDQW.name,
        assetType: contentTypeToAssetType(contentTypeWithDQW.contentType),
        onContentItem: true,
      },
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      contentTypeWithDQW.contentDetail!.dataQualityIndicators.filter((t) => t.type !== CERTIFIED_INDICATOR_TYPE)
    );

    if (details.length === 0) {
      return <></>;
    }
    return (
      <span className="tb-quality-indicator-cell" style={DataQualityIndicatorStyle}>
        <EmbeddableDataQualityStatusChip details={details} iconOnly={true} iconOnlyTabIndex={-1} siteUrls={this.props.urls} />
      </span>
    );
  }
}

function dataQualityIndicatorInfosToProps(
  props: { assetUrl: string; assetName: string; assetType: DataQualityAssetType | null; onContentItem: boolean },
  dqis: ReadonlyArray<IDataQualityIndicator>
): ReadonlyArray<DataQualityDetailProps> {
  const mappedIndicators = dqis.map((dqi) => dataQualityIndicatorInfoToProps(props, dqi));
  return removeNulls(mappedIndicators);
}

function dataQualityIndicatorInfoToProps(
  props: { assetUrl: string; assetName: string; assetType: DataQualityAssetType | null; onContentItem: boolean },
  info: IDataQualityIndicator
): DataQualityDetailProps | null {
  if (!info || !info.isActive) {
    return null;
  }

  return {
    ...props,
    assetType: props.assetType,
    author: dataQualityOwnerToTableauUser(info.owner),
    localizedDate: L10n.localizedDateTime(info.updatedAt),
    type: stringToDataQualityType(info.type),
    message: info.message,
    newTab: false,
    isSevere: info.isSevere,
  };
}

function urlForContentType(appUrls: AppUrls, contentType: ContentType, id: string): string {
  switch (contentType) {
    case ContentType.unifieddatasource:
      return appUrls.datasourceUrl(id);
    case ContentType.flow:
      return appUrls.flowUrl(id);
    case ContentType.database:
      return appUrls.catalogDatabaseUrl(id);
    case ContentType.table:
      return appUrls.catalogTableUrl(id);
    default:
      return '';
  }
}

function contentTypeToAssetType(contentType: ContentType): DataQualityAssetType | null {
  switch (contentType) {
    case ContentType.unifieddatasource:
      return 'PublishedDatasource';
    case ContentType.flow:
      return 'Flow';
    case ContentType.database:
      return 'DatabaseServer';
    case ContentType.table:
      return 'DatabaseTable';
    default:
      return null;
  }
}

function dataQualityOwnerToTableauUser(owner: DataQualityOwner | null | undefined): TableauUser {
  if (!owner) {
    return { username: null, domain: null, name: null };
  }

  return {
    username: owner.username || null,
    name: owner.displayName || null,
    domain: owner.domainName || null,
  };
}

export function stringToDataQualityType(type: string): DataQualityType {
  switch (type) {
    case DataQualityType[DataQualityType.DEPRECATED]:
      return DataQualityType.DEPRECATED;
    case DataQualityType[DataQualityType.STALE]:
      return DataQualityType.STALE;
    case DataQualityType[DataQualityType.MAINTENANCE]:
      return DataQualityType.MAINTENANCE;
    case DataQualityType[DataQualityType.SENSITIVE_DATA]:
      return DataQualityType.SENSITIVE_DATA;
    case DataQualityType[DataQualityType.EXTRACT_REFRESH_FAILURE]:
      return DataQualityType.EXTRACT_REFRESH_FAILURE;
    case DataQualityType[DataQualityType.FLOW_RUN_FAILURE]:
      return DataQualityType.FLOW_RUN_FAILURE;
    // case DataQualityType[DataQualityType.CERTIFIED]: return DataQualityType.CERTIFIED;
  }
  return DataQualityType.WARNING;
}
